import { useSelector } from 'react-redux';

/*
 [
    {
        "value": "full_access_company",
        "title": "Руководитель компании"
    },
    {
        "value": "full_access_departament",
        "title": "Полный доступ"
    },
    {
        "value": "extended_access",
        "title": "Расширенный доступ"
    },
    {
        "value": "limited_access",
        "title": "Ограниченный доступ"
    }
]
  */
 
/**
* Хук, позволяет проверить, имеет ли пользователь определенную роль в компании.
* @param {Array} roles - Массив ролей, которые нужно проверить.
* @return {boolean} - Возвращает true, если роль компании пользователя включена в roles, в противном случае false.
* @example
 const isCompanyManager = useCompanyRole(['full_access_company', 'full_access_departament']);
*/
const useCompanyRole = (roles = []) => {
  const companyRole = useSelector(state => state.user?.info?.companyRole);
  return roles.includes(companyRole);
};

export default useCompanyRole;